<template>
    <div class="wrap full-h bg-white">
        <template v-if="isPageAllowed">
            <div class="filter-bar mb20 relative">
                <el-form :inline="true" label-width="120px" class="pr100" @keyup.enter.native="submitSearch">
                    <el-row>
                        <el-col>
                            <el-form-item label="">
                                <BatchMultipleSelect
                                    ref="batchAccountSelect"
                                    :value="queryData.account"
                                    :options="accountOptionsList"
                                    :loading="accountOptionsLoading"
                                    :remote-method="remoteAccountOptionsList"
                                    @change="changeAccountOptionsSearch"
                                    @batch-submit="batchSubmitAccount"
                                    @clear-all="(val)=>clearBatchSearch(val,'account')"
                                    @change-all="(val)=>changeBatchSearchAll(val,'account')"
                                    @show-options="showSelectOptions('account')"
                                    title="账户"
                                    batch-desc="输入或粘贴账户名称或账户ID，每行一个"
                                    :clearable="true"
                                    :collapse-tags="true"
                                    placeholder="账户：请输入名称或ID关键字搜索" />
                            </el-form-item>

                            <el-form-item label="">
                                <BatchMultipleSelect
                                    ref="batchCustomerSelect"
                                    :value="queryData.customer"
                                    :options="customerOptionsList"
                                    :loading="customerOptionsLoading"
                                    :remote-method="remoteCustomerOptionsList"
                                    @change="changeCustomerOptionsSearch"
                                    @batch-submit="batchSubmitCustomer"
                                    @clear-all="(val)=>clearBatchSearch(val,'customer')"
                                    @change-all="(val)=>changeBatchSearchAll(val,'customer')"
                                    @show-options="showSelectOptions('customer')"
                                    title="客户"
                                    batch-desc="输入或粘贴客户名称，每行一个"
                                    :clearable="true"
                                    :collapse-tags="true"
                                    placeholder="客户：请输入名称关键字搜索" />
                            </el-form-item>

                            <el-form-item label="">
                                <BatchMultipleSelect
                                    ref="batchBlocSelect"
                                    :value="queryData.bloc"
                                    :options="blocOptionsList"
                                    :loading="blocOptionsLoading"
                                    :remote-method="remoteBlocOptionsList"
                                    @change="changeBlocOptionsSearch"
                                    @batch-submit="batchSubmitBloc"
                                    @clear-all="(val)=>clearBatchSearch(val,'bloc')"
                                    @change-all="(val)=>changeBatchSearchAll(val,'bloc')"
                                    @show-options="showSelectOptions('bloc')"
                                    title="集团"
                                    batch-desc="输入或粘贴集团名称，每行一个"
                                    :clearable="true"
                                    :collapse-tags="true"
                                    placeholder="集团：请输入名称关键字搜索" />
                            </el-form-item>


                            <el-form-item label="媒体：">
                                <ESelect v-model="queryData.plat_id" @change="submitSearch" clearable placeholder="全部媒体">
                                    <el-option label="全部媒体" value="">全部媒体</el-option>
                                    <el-option v-for="item in platList"
                                               :label="item.name"
                                               :value="item.id"
                                               :key="item.id">{{item.name}}
                                    </el-option>
                                </ESelect>
                            </el-form-item>
                            <el-form-item label="" class="ml30">
                                <el-button type="primary" v-if="simpleFilter" :loading="dataLoading" size="mini" class="wide-button"
                                v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: '筛选' }"
                                           @click="submitSearch">筛选
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <template v-if="!simpleFilter">
                        <el-row>
                            <el-col>
                                <el-form-item label="运营设置状态：">
                                    <ESelect clearable v-model="queryData.yy_status" @change="submitSearch" placeholder="全部">
                                        <el-option label="全部" value="">全部</el-option>
                                        <el-option label="未设置" value="0">未设置</el-option>
                                        <el-option label="已设置" value="1">已设置</el-option>
                                    </ESelect>
                                </el-form-item>
                                <el-form-item label="运营负责人：">
                                    <el-input v-model.trim="queryData.yy_name" clearable placeholder="根据运营负责人名称关键字搜索"
                                              style="width: 260px;"></el-input>
                                </el-form-item>
                                <el-form-item label="运营负责人部门：">
                                    <ESelect v-model="queryData.yy_group_id" @change="submitSearch" clearable>
                                        <el-option label="全部部门" value="">全部部门</el-option>
                                        <el-option v-for="item in YYGroupList" :label="item.group_name"
                                                   :value="item.group_id"
                                                   :key="'yy_'+item.group_id">{{item.group_name}}
                                        </el-option>
                                    </ESelect>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="pageFieldsNames.includes('authorize_user')">
                            <el-col>
                                <el-form-item label="授权状态：">
                                    <ESelect v-model="queryData.authorize_status" @change="submitSearch" clearable placeholder="全部">
                                        <el-option label="全部" value="">全部</el-option>
                                        <el-option label="未设置" value="0">未设置</el-option>
                                        <el-option label="已设置" value="1">已设置</el-option>
                                    </ESelect>
                                </el-form-item>
                                <el-form-item label="授权人：">
                                    <el-input v-model.trim="queryData.authorize_name" clearable placeholder="根据授权人名称关键字搜索"
                                              style="width: 260px;"></el-input>
                                </el-form-item>
                                <el-form-item label="授权人部门：">
                                    <ESelect v-model="queryData.authorize_group_id" @change="submitSearch" clearable>
                                        <el-option label="全部部门" value="">全部部门</el-option>
                                        <el-option v-for="item in authGroupList" :label="item.group_name"
                                                   :value="item.group_id"
                                                   :key="'auth_'+item.group_id">{{item.group_name}}
                                        </el-option>
                                    </ESelect>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="mb20 ml30">
                                <el-button type="primary" size="mini" class="wide-button" :loading="dataLoading" @click="submitSearch" v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: '筛选' }">筛选
                                </el-button>
                                <div class="inline-block" v-if="queryData.yy_name||queryData.yy_group_id">
                                    <el-checkbox v-model="queryData.not_contain_history" @change="submitSearch"
                                                 true-label="1" false-label="0" class="ml20">仅搜索当前运营负责人
                                    </el-checkbox>
                                    <span class="text-color-gray">（不勾选此项时，按照账户历史全部负责人搜索）</span>
                                </div>
                            </el-col>
                        </el-row>
                    </template>
                </el-form>
                <div class="toggle-bar inline-block">
                    <!--<el-button type="primary" size="mini">更多筛选</el-button>-->
                    <el-button size="mini" v-if="simpleFilter"
                    v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: '筛选(更多筛选)' }"
                    @click="simpleFilter=!simpleFilter" class="wide-button">
                        更多筛选
                    </el-button>
                    <el-button size="mini" v-else @click="simpleFilter=!simpleFilter" class="wide-button">收起</el-button>
                </div>
            </div>
            <div class="data-list mb20">
                <el-alert
                    v-if="!mediaAccountWriteEnabled"
                    class="mb10"
                    title="媒体账户关系已迁移至智投，本页面仅供查询，请前往智投维护。"
                    type="info"
                    :closable="false" />
                <div class="batch-tool-bar mb10">
                    <div>
                        <el-button type="primary" plain v-if="mediaAccountWriteEnabled && pageFuncNames.includes('set_yy')" :disabled="accountSelected.length<=0"
                        v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: '批量设置运营' }"
                        @click="batchYY" size="mini">
                            批量设置运营
                        </el-button>
                        <el-button type="primary" plain v-if="mediaAccountWriteEnabled && pageFuncNames.includes('authorize')" :disabled="accountSelected.length<=0"
                        v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: '批量授权' }"
                        @click="batchAuth" size="mini">批量授权
                        </el-button>
                        <span class="ml20" v-if="accountSelected.length>0">
                        已选中 {{accountSelected.length}} 条
                    </span>
                    </div>
                    <p class="tips text-color-gray pl10 mt4">运营负责人与授权人的区别：运营负责人按照负责时间分配消耗，计算绩效。授权人仅有此账户权限，不参与绩效分配。</p>
                </div>
                <div class="table-wrap">
                    <jt-table
                        ref="dataTable"
                        :data="dataList"
                        v-loading="dataLoading"
                        @selection-change="accountSelectionChange"
                        tooltip-effect="dark"
                        :header-cell-style="{background:'#e8eaec',color:'#333'}"
                        stripe
                        style="width: 100%;">
                        <el-table-column
                            type="selection"
                            align="center"
                            width="55">
                        </el-table-column>
                        <el-table-column
                            v-if="pageFieldsNames.includes('company_id')"
                            prop="company_id"
                            align="center"
                            min-width="150px"
                            label="账户ID">
                            <template slot-scope="scope">
                                <p class="tal">{{scope.row.show_company_id||'--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="pageFieldsNames.includes('company_name')"
                            prop="user_name"
                            align="center"
                            min-width="250px"
                            label="账户名称">
                            <template slot-scope="scope">
                                <p class="tal">{{scope.row.user_name||'--'}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="pageFieldsNames.includes('user_name')"
                            prop="company_name"
                            align="center"
                            min-width="220px"
                            label="所属客户">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.company_name">--</span>
                                <span v-else-if="scope.row.company_name.length<=15">{{scope.row.company_name}}</span>
                                <el-tooltip v-else :content="scope.row.company_name" placement="top">
                                    <span>{{scope.row.company_name.substring(0,15)}}...</span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="pageFieldsNames.includes('plat_name')"
                            prop="plat_name"
                            align="center"
                            min-width="80px"
                            label="所属媒体">
                        </el-table-column>
                        <el-table-column
                            prop="bloc_name"
                            align="center"
                            min-width="80px"
                            label="所属集团">
                        </el-table-column>
                        <el-table-column
                            v-if="pageFieldsNames.includes('name')"
                            prop="name"
                            align="center"
                            min-width="180px"
                            label="当前运营负责人">
                            <template slot-scope="scope">
                                <span v-if="scope.row.name">{{scope.row.name}} <i class="ml10">{{scope.row.operation_time}}</i></span>
                                <span v-else class="text-color-error">未设置</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            v-if="pageFieldsNames.includes('authorize_user')"
                            prop="authorize_user"
                            min-width="160px"
                            label="授权人">
                            <template slot-scope="scope">
                                <span v-if="!scope.row.authorize_user">--</span>
                                <span v-else-if="scope.row.authorize_user.length<=15">{{scope.row.authorize_user}}</span>
                                <el-tooltip v-else :content="scope.row.authorize_user" placement="top">
                                    <span>{{scope.row.authorize_user.substring(0,11)}}...</span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            align="center"
                            fixed="right"
                            min-width="180px"
                            label="操作">
                            <template slot-scope="scope">
                                <el-link type="primary" v-if="mediaAccountWriteEnabled && pageFuncNames.includes('set_yy')" class="ml2 mr2"
                                v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: '列表(设置运营)' }"
                                @click="showYYModal(scope.row)">设置运营</el-link>
                                <el-link type="primary" v-if="pageFuncNames.includes('get_yy_history')" class="ml2 mr2"
                                v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: '列表(查看运营负责人)' }"
                                @click="showYYHistoryModal(scope.row)">查看运营历史
                                </el-link>
                                <el-link type="primary" v-if="mediaAccountWriteEnabled && pageFuncNames.includes('authorize')" class="ml2 mr2"
                                v-matomo="{behaviorCategory: '媒体账户绑定', event: '点击',  name: '列表(授权)' }"
                                @click="showAccountAuthModal(scope.row)">授权
                                </el-link>
                            </template>
                        </el-table-column>
                    </jt-table>
                </div>
                <div class="page-bar tac mt20">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="queryData.pn"
                        :page-sizes="[30,50,100]"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCnt">
                    </el-pagination>
                </div>
            </div>
            <YYHistoryModal ref="yyHistoryModal" :account="actionAccount"/>
            <AccountAuthModal ref="accountAuthModal" :account-list="accountSelected" @update="updateListData"/>
            <BatchYYModal ref="batchYYModal" :account-list="accountSelected" @update="updateListData"/>
            <SingleYYModal ref="singleYYModal" :account="actionAccount" @update="updateListData"/>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>可在此页面设置、查看账户运营负责人与授权人 。</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import API from '@/api/mediaAccount.js';
    import YYHistoryModal from './modal/YYHistory';
    import AccountAuthModal from './modal/accountAuth';
    import BatchYYModal from './modal/batchYY';
    import SingleYYModal from './modal/singleYY';
    import {pageMixin} from '../mixins/pageMixin';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import BatchMultipleSelect from '@/components/BatchMultipleSelect';
    import { uniq,cloneDeep,isEqual } from 'lodash';


    export default {
        name: "AccountManagement",
        mixins: [pageMixin],
        components: {
            YYHistoryModal,
            AccountAuthModal,
            BatchYYModal,
            SingleYYModal,
            NoPermissionInfo,
            BatchMultipleSelect,
        },
        data() {
            return {
                mediaAccountWriteEnabled: false,
                simpleFilter: true,
                dataLoading: false,
                queryData: {
                    search: '',
                    plat_id: null,
                    yy_status: '',
                    yy_name: '',
                    yy_group_id: '',
                    authorize_status: '',
                    authorize_name: '',
                    authorize_group_id: '',
                    not_contain_history: '',
                    pn: 1,
                    rn: 30,
                    account:[],
                    customer:[],
                    bloc:[],
                },
                totalCnt: 0,
                platList: [],
                YYGroupList: [],
                authGroupList: [],
                dataList: [
                    {
                        id: '1',
                    },
                ],
                actionAccount: {
                    plat_id: '',
                    company_id: '',
                    company_name: '',
                },
                accountSelected: [],
                actionAccountList: [],
                accountOptionsList:[],  //  筛选条件下拉列表
                accountOptionsLoading:false,
                allAccountOptions:[],

                customerOptionsList:[],  //  筛选条件下拉列表
                customerOptionsLoading:false,
                allCustomerOptions:[],

                blocOptionsList:[], //  筛选条件下拉列表
                blocOptionsLoading:false,
                allBlocOptions:[],
            }
        },
        computed:{
            ...mapState({
                queryAccount: state => state.mediaAccount.queryAccount,
            }),
        },
        watch:{
            queryAccount(){
                if(this.queryAccount.length>0){
                    this.resetQuery();
                    this.queryData.account = this.queryAccount.map(item=>item.id);
                    this.queryData.plat_id = '';
                    this.getDataList();
                    this.$store.commit('mediaAccount/CLEAR_QUERY_ACCOUNT');
                }
            }
        },
        async created() {
            // this.getPageAllowAction();

            await this.getSearchList(true);
            let routeParams = this.$route.params||{};
            let paramsList = (routeParams.list||[]).map(item=>item.id);
            let routeQuery = this.$route.query||{};
            let accountCid = routeQuery.query_account||'';

            if(paramsList.length>0){
                this.resetQuery();
                this.queryData.account = uniq(paramsList);
            }else if(accountCid.length>0){
                let accountListStr = localStorage.getItem("wordOrderAccount_"+accountCid);
                if(accountListStr){
                    let accountList = JSON.parse(accountListStr);
                    let accountIdArr = Array.isArray(accountList)?accountList:[accountList];
                    this.queryData.account = accountIdArr;
                    console.log('routeParams',this.queryData,accountCid);
                    localStorage.removeItem("wordOrderAccount_"+accountCid);
                    this.queryData.plat_id = '';
                }
            }
            this.getDataList();
        },
        mounted(){
            // console.log('1.mounted');
        },
        methods: {
            resetQuery(){
                // 仅清空筛选项，不执行搜索
                this.queryData = {
                    search: '',
                    plat_id: '',
                    yy_status: '',
                    yy_name: '',
                    yy_group_id: '',
                    authorize_status: '',
                    authorize_name: '',
                    authorize_group_id: '',
                    not_contain_history: '',
                    pn: 1,
                    rn: 30,
                    account:[],
                    customer:[],
                    bloc:[],
                };
            },
            async getSearchList(isSetDefaultPlat) {
                await API.getPlatCompanySearchList().then(res => {
                    let resData = res.data || {};
                    if (res.code == 200) {
                        this.mediaAccountWriteEnabled = resData.write_enabled !== false;
                        this.platList = resData.plat_list;
                        this.YYGroupList = resData.yy_group;
                        this.authGroupList = resData.authorize_group;
                        if(isSetDefaultPlat){
                            let firstPlat = resData.plat_list[0]||{};
                            this.queryData.plat_id = firstPlat.id;
                        }
                    } else {
                        console.log('getPlatCompanySearchList error', res);
                        this.platList = [];
                        this.YYGroupList = [];
                        this.authGroupList = [];
                    }
                }, (err) => {
                    console.log('getPlatCompanySearchList error', err);
                    this.platList = [];
                    this.YYGroupList = [];
                    this.authGroupList = [];
                });
            },
            getDataList() {
                this.dataLoading = true;
                let reqData = cloneDeep(this.queryData);
                API.getDataList(reqData).then(res => {
                    /* 判断查询条件是否相同，如果相同则表示最新的请求 */
                    let isEqualVal = isEqual(reqData, this.queryData);
                    if(isEqualVal){
                        let resData = res.data || {};
                        this.dataLoading = false;
                        this.dataList = resData.list||[];
                        this.totalCnt = resData.totalCnt;
                    }
                }, (err) => {
                    console.log('getUserList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });

            },
            submitSearch() {
                this.getDataList();
            },
            handleSizeChange(val) {
                this.queryData.rn = val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn = val;
                this.getDataList();
            },
            showYYHistoryModal(row) {
                this.actionAccount = row;
                this.$refs.yyHistoryModal.showModal();
            },
            showAccountAuthModal(row) {
                this.$refs.accountAuthModal.showModal([row]);
            },
            accountSelectionChange(val) {
                this.accountSelected = val.map(item => item);
            },
            batchAuth() {
                this.$refs.accountAuthModal.showModal(this.accountSelected);
            },
            batchYY() {
                this.$refs.batchYYModal.showModal();
            },
            showYYModal(row) {
                this.actionAccount = row;
                this.$refs.singleYYModal.showModal();
            },
            updateListData(){
                this.getSearchList(false);
                this.getDataList();
            },
            remoteAccountOptionsList(query){
                console.log('remoteAccountOptionsList',query);
                if (query !== '') {
                    this.accountOptionsLoading = true;
                    API.getAccountOptionList({
                        search:query,
                    }).then(res=>{
                        this.accountOptionsLoading = false;
                        let resData = res.data||{};
                        this.accountOptionsList = (resData.list||[]).map(item=>{
                            return {
                                value:item.company_id,
                                label:item.user_name+'('+item.show_company_id+')',
                            }
                        });

                        this.accountOptionsList.forEach(item=>{
                            if(!this.allAccountOptions.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                this.allAccountOptions.push({...item});
                            }
                        });
                    },err=>{
                        this.accountOptionsLoading = false;
                        console.log('getAccountOptionList err',err);
                        this.accountOptionsList = [];
                    })
                } else {
                    this.options = [];
                }
            },
            changeAccountOptionsSearch(val){
                this.queryData.account = [...val];
            },
            batchSubmitAccount(con){
                API.getAccountOptionList({
                    batch_search:con,
                }).then(res=>{
                    this.$refs.batchAccountSelect.hideBatchLoading();

                    let resData = res.data || {};
                    let successList = resData.list||[];
                    let errList = resData.err_list||[];

                    if(errList.length>0){
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>未找到以下账户，请核实，是否需要剔除未找到的账户?</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(()=>{
                            this.addBatchAccount(successList);
                            this.$refs.batchAccountSelect.hideBatchModal();
                        });
                    }else{
                        this.addBatchAccount(successList);
                        this.$refs.batchAccountSelect.hideBatchModal();
                    }
                },err=>{
                    console.log('getAccountOptionList batch error', err);
                    this.$refs.batchAccountSelect.hideBatchLoading();
                    this.$message.error(err.info||'请求有误');
                })
            },
            addBatchAccount(list){
                let accountIdList = this.accountOptionsList.map(item=>item.value);
                (list||[]).forEach(item=>{
                    if(!accountIdList.includes(item.company_id)){
                        this.accountOptionsList.push({
                            value:item.company_id,
                            label:item.user_name+'('+item.show_company_id+')',
                        });

                        this.accountOptionsList.forEach(item=>{
                            if(!this.allAccountOptions.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                this.allAccountOptions.push({...item});
                            }
                        });
                    }
                    if(!this.queryData.account.includes(item.company_id)){
                        this.queryData.account.push(item.company_id);
                    }
                })
            },
            remoteCustomerOptionsList(query){
                console.log('remoteCustomerOptionsList',query);
                if (query !== '') {
                    this.customerOptionsLoading = true;
                    API.getCustomerOptionList({
                        search:query,
                    }).then(res=>{
                        this.customerOptionsLoading = false;
                        let resData = res.data||{};
                        this.customerOptionsList = (resData.list||[]).map(item=>{
                            return {
                                value:item.company_name,
                                label:item.company_name,
                            }
                        });

                        this.customerOptionsList.forEach(item=>{
                            if(!this.allCustomerOptions.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                this.allCustomerOptions.push({...item});
                            }
                        });
                    },err=>{
                        this.customerOptionsLoading = false;
                        console.log('getCustomerOptionList err',err);
                        this.customerOptionsList = [];
                    })
                } else {
                    this.customerOptionsList = [];
                }
            },
            remoteBlocOptionsList(query){
                console.log('remoteBlocOptionsList',query);
                if (query !== '') {
                    this.blocOptionsLoading = true;
                    API.getBlocOptionList({
                        search:query,
                    }).then(res=>{
                        this.blocOptionsLoading = false;
                        let resData = res.data||{};
                        this.blocOptionsList = (resData.list||[]).map(item=>{
                            return {
                                value:item.bloc_name,
                                label:item.bloc_name,
                            }
                        });

                        this.blocOptionsList.forEach(item=>{
                            if(!this.allBlocOptions.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                this.allBlocOptions.push({...item});
                            }
                        });
                    },err=>{
                        this.blocOptionsLoading = false;
                        console.log('getBlocOptionList err',err);
                        this.blocOptionsList = [];
                    })
                } else {
                    this.blocOptionsList = [];
                }
            },
            changeCustomerOptionsSearch(val){
                this.queryData.customer = [...val];
            },
            changeBlocOptionsSearch(val){
                this.queryData.bloc = [...val];
            },
            batchSubmitCustomer(con){
                API.getCustomerOptionList({
                    batch_search:con,
                }).then(res=>{
                    this.$refs.batchCustomerSelect.hideBatchLoading();

                    let resData = res.data || {};
                    let successList = resData.list||[];
                    let errList = resData.err_list||[];

                    if(errList.length>0){
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>未找到以下客户，请核实，是否需要剔除未找到的客户?</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(()=>{
                            this.addBatchCustomer(successList);
                            this.$refs.batchCustomerSelect.hideBatchModal();
                        });
                    }else{
                        this.addBatchCustomer(successList);
                        this.$refs.batchCustomerSelect.hideBatchModal();
                    }
                },err=>{
                    console.log('getCustomerOptionList batch error', err);
                    this.$refs.batchCustomerSelect.hideBatchLoading();
                    this.$message.error(err.info||'请求有误');
                })
            },
            batchSubmitBloc(con){
                API.getBlocOptionList({
                    batch_search:con,
                }).then(res=>{
                    this.$refs.batchBlocSelect.hideBatchLoading();

                    let resData = res.data || {};
                    let successList = resData.list||[];
                    let errList = resData.err_list||[];

                    if(errList.length>0){
                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        htmlStr += '<p>未找到以下集团，请核实，是否需要剔除未找到的集团?</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(()=>{
                            this.addBatchBloc(successList);
                            this.$refs.batchBlocSelect.hideBatchModal();
                        });
                    }else{
                        this.addBatchBloc(successList);
                        this.$refs.batchBlocSelect.hideBatchModal();
                    }
                },err=>{
                    console.log('getCustomerOptionList batch error', err);
                    this.$refs.batchCustomerSelect.hideBatchLoading();
                    this.$message.error(err.info||'请求有误');
                })
            },
            addBatchCustomer(list){
                console.log('addBatchCustomer',list);
                let customerIdList = this.customerOptionsList.map(item=>item.value);
                (list||[]).forEach(item=>{
                    if(!customerIdList.includes(item.company_name)){
                        this.customerOptionsList.push({
                            value:item.company_name,
                            label:item.company_name,
                        });
                        this.customerOptionsList.forEach(item=>{
                            if(!this.allCustomerOptions.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                this.allCustomerOptions.push({...item});
                            }
                        });
                    }
                    if(!this.queryData.customer.includes(item.company_name)){
                        this.queryData.customer.push(item.company_name);
                    }
                })
            },
            addBatchBloc(list){
                console.log('addBatchBloc',list);
                let blocIdList = this.blocOptionsList.map(item=>item.value);
                (list||[]).forEach(item=>{
                    if(!blocIdList.includes(item.bloc_name)){
                        this.blocOptionsList.push({
                            value:item.bloc_name,
                            label:item.bloc_name,
                        });
                        this.blocOptionsList.forEach(item=>{
                            if(!this.allBlocOptions.find(inner=>inner.label==item.label&&inner.value==item.value)){
                                this.allBlocOptions.push({...item});
                            }
                        });
                    }
                    if(!this.queryData.bloc.includes(item.bloc_name)){
                        this.queryData.bloc.push(item.bloc_name);
                    }
                })
            },
            clearBatchSearch(val=[],filter){
                val.forEach(item=>{
                    let index = this.queryData[filter].findIndex(inner=>inner==item);
                    if(index!=-1){
                        this.queryData[filter].splice(index,1);
                    }
                })

            },
            changeBatchSearchAll(val,filter){
                let oldVal = this.queryData[filter];
                let newVal = [...val].filter(item=>!oldVal.includes(item));
                this.$set(this.queryData,filter,oldVal.concat(newVal));
            },
            showSelectOptions(type){
                let value = this.queryData[type]||[];
                this[type+'OptionsList'] = value.map(item=>{
                    let allOptions = [];
                    if(type=='account'){
                        allOptions = this.allAccountOptions||[];
                    }else if(type=='customer'){
                        allOptions = this.allCustomerOptions||[];
                    }else if(type=='bloc'){
                        allOptions = this.allBlocOptions||[];
                    }
                    let actionItem = allOptions.find(inner=>inner.value==item);
                    return {
                        label:actionItem?actionItem.label:item,
                        value:item,
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .filter-bar {
        background-color: #f8f8f9;
        padding: 20px 20px 0;
        border-radius: 5px;
    }

    .toggle-bar {
        position: absolute;
        right: 20px;
        top: 18px;
    }

    .wide-button {
        width: 80px;
    }
    .pr100{
        padding-right: 100px;
    }
</style>
